import { Button } from "@aix/ui"
import { trpc } from "~/lib/trpc"
import toast from "react-hot-toast"

export default function DebugTab() {
  // Queries
  const { data: allCoaches, refetch: refetchCoaches, isLoading: isLoadingCoaches } = trpc.coaches.list.useQuery({})

  const handleRefreshAll = () => {
    refetchCoaches()
      .then(() => toast.success("All data refreshed"))
      .catch(() => toast.error("Failed to refresh data"))
  }

  const handleCopyToClipboard = (data: any, label: string) => {
    void navigator.clipboard.writeText(JSON.stringify(data, null, 2))
    toast.success(`${label} copied to clipboard`)
  }

  return (
    <div className="p-6 space-y-6">
      {/* Actions Section */}
      <div className="bg-secondary border-4 border-border p-6 shadow-lg">
        <h2 className="text-xl font-bold mb-4 text-primary">🔧 Actions</h2>
        <div className="flex flex-wrap gap-3">
          <Button
            onClick={handleRefreshAll}
            variant="outline"
            className="border-2 border-border"
            loading={isLoadingCoaches}
          >
            🔄 Refresh All Data
          </Button>
        </div>
      </div>

      {/* Live Data Display */}
      <div className="grid grid-cols-1 gap-6">
        {/* All Coaches */}
        <div className="bg-secondary border-4 border-border p-6 shadow-lg">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-bold text-primary">👥 All Coaches ({allCoaches?.coaches?.length || 0})</h2>
            <Button
              onClick={() => handleCopyToClipboard(allCoaches, "All Coaches")}
              variant="outline"
              size="sm"
              className="border-2 border-border"
            >
              📋 Copy
            </Button>
          </div>

          <div className="bg-background border-2 border-border p-4 max-h-96 overflow-auto">
            {isLoadingCoaches ? (
              <div className="text-center text-muted-foreground">Loading...</div>
            ) : (
              <pre className="text-xs font-mono whitespace-pre-wrap">{JSON.stringify(allCoaches, null, 2)}</pre>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
